import React, { useMemo } from 'react';
import { Box, Button, ButtonGroup, ButtonGroupProps, SpaceBetween } from '@amzn/awsui-components-react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { JAM_EVENT_DETAILS_ROUTES } from '@/src/routes';
import { i18nKeys } from '@/src/utils/i18n.utils';
import { useToolPanel } from '@/src/store/tool-panel.context';
import { useAITeammate } from '@/src/hooks/store/useAITeammate';

export const HeaderButtonGroup: React.FC<{
  isFullScreen: boolean;
  eventName: string;
  disabled: boolean;
  onResetConversation: () => void;
  onFeedbackModalActivation: () => void;
}> = ({ isFullScreen, eventName, onResetConversation, onFeedbackModalActivation, disabled }) => {
  const { t } = useTranslation();
  const { setViewModalityTransfer } = useAITeammate(eventName)();
  const { toggleAITeammateChat } = useToolPanel();
  const historyHook = useHistory();
  const items = useMemo(() => {
    const arr: ButtonGroupProps.ItemOrGroup[] = [];
    if (!isFullScreen) {
      arr.push({
        type: 'icon-button',
        id: 'go-fullscreen',
        iconName: 'full-screen',
        disabled,
        text: t(i18nKeys.conversationalAI.goFullScreen),
      });
    } else {
      arr.push({
        type: 'icon-button',
        id: 'go-back',
        iconName: 'exit-full-screen',
        disabled,
        text: t(i18nKeys.participants.buttons.goBackBtn),
      });
    }
    arr.push({
      type: 'icon-button',
      id: 'reset-conversation',
      iconName: 'refresh',
      disabled,
      text: t(i18nKeys.conversationalAI.resetConversation.button),
    });
    return arr;
  }, [isFullScreen, disabled, t]);
  return (
    <SpaceBetween direction="horizontal" size="xxs">
      <ButtonGroup
        variant="icon"
        onItemClick={({ detail }) => {
          switch (detail.id) {
            case 'go-fullscreen':
              toggleAITeammateChat(false);
              setViewModalityTransfer(true);
              historyHook.push(JAM_EVENT_DETAILS_ROUTES.ConversationalAI.resolve(eventName));
              break;
            case 'go-back':
              setViewModalityTransfer(true);
              historyHook.goBack();
              toggleAITeammateChat(true);
              break;
            case 'reset-conversation':
              onResetConversation();
              break;
          }
        }}
        items={items}
      />
      <Box display="inline-block" padding={{ top: 'xxs', left: 'xs' }} margin={{ top: 'xxxs' }}>
        <Button variant="inline-link" iconName="contact" onClick={onFeedbackModalActivation}>
          {t(i18nKeys.conversationalAI.jammyFeedback.giveFeedback)}
        </Button>
      </Box>
    </SpaceBetween>
  );
};

export default HeaderButtonGroup;
